export default {
    resourceLabel:"Resources",
    resourceLabelAlt:"Resource",
    resourceDescription:"Access comprehensive learning materials for your language studies",
    searchResourcePlaceholder:"Search resources",
    recentResourcesLabel:"Recent resources",
    recentlyViewedResourcesLabel:"Recently viewed",
    loadResourceActionButtonLabel:"Load Resource",

    resourceLibraryTitle:"Resource Library",
    resourceLibraryDescription:"Explore comprehensive learning materials",
    backToResourcesActionButtonLabel:"Back to Resources",
    resourceReviewCountLabel:"({{reviewCount}} reviews)",
}